export const columns = [
  {
    customWidth: 128,
    Header: () => 'WMS Order #',
    accessor: 'orderNo',
    Cell: ({ row }) => <div>{row.original.orderNo}</div>,
  },
  {
    id: 'bulkSlipNo',
    customWidth: 128,
    Header: 'Bulk Slip No',
    accessor: 'bulkSlipNo',
    Cell: ({ row }) => <div>{row.original.bulkReferance}</div>,
  },
  {
    id: 'consNo',
    customWidth: 128,
    Header: 'Cons No',
    accessor: 'consNo',
    Cell: ({ row }) => <div>{row.original.consNo}</div>,
  },
  {
    id: 'noOfSKU',
    customWidth: 128,
    Header: 'No of SKU',
    accessor: 'noOfSKU',
    Cell: ({ row }) => (
      <div>{row.original.partnerOrder?.partnerOrderLines?.length ?? 0}</div>
    ),
  },
  {
    id: 'orderType',
    customWidth: 128,
    Header: () => 'Order Type',
    accessor: 'orderType',
    Cell: ({ row }) => (
      <div className='line-clamp-2'>
        {row.original?.partnerOrder?.orderType}
      </div>
    ),
  },
  {
    id: 'RDD',
    customWidth: 300,
    Header: () => 'RDD',
    accessor: 'RDD',
    Cell: ({ row }) => (
      <div className='line-clamp-2'>
        {row.original.partnerOrder?.dateWanted &&
        row.original.partnerOrder?.despatchBefore
          ? `${new Date(
              row.original.partnerOrder.dateWanted,
            ).toLocaleDateString('en-GB', {
              timeZone: 'Australia/Sydney',
            })} - ${new Date(
              row.original.partnerOrder.despatchBefore,
            ).toLocaleDateString('en-GB', { timeZone: 'Australia/Sydney' })}`
          : row.original.partnerOrder?.dateWanted
          ? new Date(row.original.partnerOrder.dateWanted).toLocaleDateString(
              'en-GB',
              { timeZone: 'Australia/Sydney' },
            )
          : row.original.partnerOrder?.despatchBefore
          ? new Date(
              row.original.partnerOrder.despatchBefore,
            ).toLocaleDateString('en-GB', { timeZone: 'Australia/Sydney' })
          : '-'}
      </div>
    ),
  },
  {
    id: 'carrierType',
    customWidth: 128,
    Header: () => 'Courier Type',
    accessor: 'carrierType',
    Cell: () => true,
  },

  {
    id: 'destination',
    customWidth: 128,
    Header: () => 'Destination',
    accessor: 'destination',
    Cell: ({ row }) => (
      <div className='line-clamp-2'>
        {row.original?.partnerOrder?.shippingAddress?.countryCode}
      </div>
    ),
  },
  {
    id: 'dimension',
    customWidth: 128,
    Header: () => 'Dimensions',
    accessor: 'dimension',
    Cell: () => true,
  },
  {
    id: 'weight',
    customWidth: 128,
    Header: () => 'Weight',
    accessor: 'weight',
    Cell: ({ row }) => (
      <div className='line-clamp-2'>
        {row.original?.shipments[0]?.packages[0]?.weight ?? 0}
      </div>
    ),
  },
]

export default columns
